module.exports = __webpack_public_path__ + "img/ric.bddd5550.svg";